import React, { useLayoutEffect, useRef } from 'react';
import useStayScrolled from 'react-stay-scrolled';


import MessageList from './MessaggeList';
import Composer from './Composer';
import { useGlobalState } from '../state';


function ChatLayout() {
  // HACK to fix scrolling on firefox
  const [messagesByChannel,] = useGlobalState('messagesByChannel')
  const [currentChannel,] = useGlobalState('currentChannel');
  const messages = messagesByChannel && messagesByChannel[currentChannel]
  const messageCount = messages ? messages.length : 0;
  const messageListContainerRef = useRef();
  const { stayScrolled } = useStayScrolled(messageListContainerRef);
  useLayoutEffect(() => {
    stayScrolled();
  }, [messageCount])
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div ref={messageListContainerRef} style={{ flex: 1, overflow: 'auto', display: 'flex' }}>
        <MessageList />
      </div>
      <div>
        <Composer />
      </div>
    </div>
  );
}

export default ChatLayout;
